import api from "@/api/axios";
import { API } from "@/App";
import React, { useContext, useEffect, useState } from "react";

// ============== Auth Context ==============
const AuthContext = React.createContext({ user: null, token: null, login: async () => {}, logout: () => {} });
const useAuth = () => useContext(AuthContext);

function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const u = localStorage.getItem("auth_user");
    return u ? JSON.parse(u) : null;
  });
  const [token, setToken] = useState(() => localStorage.getItem("auth_token"));

  const login = async (email, password) => {
    const resp = await api.post(`${API}/auth/login`, { email, password });
    setUser(resp.data.user);
    setToken(resp.data.token);
    localStorage.setItem("auth_user", JSON.stringify(resp.data.user));
    localStorage.setItem("auth_token", resp.data.token);
  };
  const logout = () => {
    setUser(null); setToken(null);
    localStorage.removeItem("auth_user");
    localStorage.removeItem("auth_token");
  };

  useEffect(() => {
    api.defaults.headers.common["Authorization"] = token ? `Bearer ${token}` : undefined;
  }, [token]);

  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export {
    useAuth,
    AuthContext,
    AuthProvider
}